import { Inter, poppins } from "@/components/common/fonts";
import { Layout, Row, Button } from "antd";
/**
 * styled를 import할 때 default를 import하도록 한다.
 * - https://github.com/vercel/next.js/discussions/60150#discussioncomment-7998570
 */
import styled from "styled-components";

export const RootLayout = styled(Layout)`
  min-height: 100vh;
`;

export const RootContent = styled(Layout.Content)`
  display: flex;
  background: ${({ theme }) => theme.colorBgBase};
  padding: 10px;
  section.ant-layout.ant-layout-has-sider & {
    margin: 0 0 0 15px;
  }

  @media screen and (max-width: 700px) {
    section.ant-layout.ant-layout-has-sider & {
      margin: 0px;
    }
  }
`;

export const StyledSider = styled(Layout.Sider)`
  &.ant-layout-sider {
    background: ${({ theme }) => theme.colorBgBase};
  }
`;

export const StyledFooter = styled(Layout.Footer)`
  text-align: center;
`;

export const MainLayout = styled(Layout)`
  height: 100vh;
  background: #ffffff;
  /* background: #f5f5f5; */
`;

export const MainHeaderLayout = styled(Layout.Header)<{ isHybridApp?: boolean }>`
  /* height: 64px; */
  height: 124px;
  color: #ff0000;
  background: ${({ theme }) => theme.colorBgBase};
  border-bottom: 1px solid #eaeaea;

  position: fixed;
  z-index: 998;
  left: 0;
  top: 0;
  overflow: auto;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 768px) {
    height: ${({ isHybridApp }) => (isHybridApp ? "60px" : "88px")};
  }
`;

export const StyledMaxWidthRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const MainSiderLayout = styled(Layout.Sider)`
  border-right: 1px solid #eaeaea;

  position: fixed !important;
  left: 0;
  /* top: 64px; */
  top: 124px;
  overflow: auto;
  /* height: calc(100vh - 64px); */
  height: calc(100vh - 124px);

  &.ant-layout-sider {
    background: ${({ theme }) => theme.colorBgBase};
  }

  &.showWorkspaceMenu {
    z-index: 10;
  }

  @media screen and (max-width: 768px) {
    top: 88px;
    height: calc(100vh - 88px);
  }
`;

export const MainContentLayout = styled(Layout.Content)<{ isHybridApp: boolean }>`
  // display: flex;
  // background: rgb(246, 246, 248);
  // padding: 10px;

  /* padding-top: 64px; */
  padding-top: 124px;

  section.ant-layout.ant-layout-has-sider & {
    margin: 0 0 0 15px;
  }

  @media screen and (max-width: 768px) {
    padding-top: ${({ isHybridApp }) => (isHybridApp ? "60px" : "88px")};
  }
`;

export const MainFooterLayout = styled(Layout.Footer)`
  text-align: center;
`;

export const StyledHeaderMain = styled.div`
  box-sizing: border-box;
  /* padding: 0px 15px; */
  padding: 0 15px;
  /* padding: 5px 15px; */
  display: flex;
  /* height: 100%; */
  height: 64px;
  width: 100%;
  align-items: center;
  overflow: hidden;
  background: ${({ theme }) => theme.colorBgBase};

  .btnAccount {
    width: 80px;
    border-color: rgba(0, 0, 0, 0);
    box-shadow: 0 0 0 rgba(0, 0, 0, 0.02);
    vertical-align: middle;
  }

  .btnAccount:hover {
    border-color: rgba(0, 0, 0, 0);
    box-shadow: 0 0 0 rgba(0, 0, 0, 0.02);
  }

  &.landscape {
    flex-direction: row;
    .script-editor {
      min-width: 300px;
      width: 100%;
    }
  }
  &.portrait {
    flex-direction: column;
    .script-editor {
      min-height: 300px;
      height: 64px;
    }
  }
  @media screen and (max-width: 768px) {
    height: 48px;
    margin-top: -1px;
  }
`;

export const StyledMenuItem = styled(Row)`
  /* height: 75px; */
  padding: 0px 10px 0px 10px;
  border-bottom: 1px solid #eaeaea;
`;

export const StyledUpgradeCol = styled.div`
  text-align: left;
  width: 100%;
  padding: 10px 8px;
  /* cursor: pointer; */
  div:nth-child(1) {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    font-size: 14px;
    > span {
      display: flex;
      align-items: center;
    }
  }
  /* div:nth-child(2) {
    margin-top: 10px;
  }
  div:nth-child(3) {
    color: "#777777";
    font-size: 10px;
    margin-top: 10px;
  } */

  .userInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 10px;

    .name {
      width: 140px;

      font-size: 14px;
      line-height: 17px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .subscription {
      font-size: 11px;
      font-weight: 400;
      line-height: 13px;
      letter-spacing: 0em;
      text-align: left;
      color: #a0a0a0;
    }
  }

  .progress-bar {
    margin-top: 10px;
  }

  .creditInfo {
    display: flex;
    gap: 5px;
    margin-top: 7px;
    /* justify-content: space-between; */

    .credit-item {
      font-size: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      position: relative;
      color: black;

      .dot {
        &::after {
          content: "";
          display: block;
          position: absolute;
          top: 50%;
          left: -1px;
          transform: translateY(-50%);
          width: 3px;
          height: 3px;
          border-radius: 100%;
          background-color: black;
        }

        /* &::before {
          content: "";
          display: block;
          position: absolute;
          top: 50%;
          left: 5px;
          transform: translate(-50%, -50%);
          width: 5px; 
          height: 5px; 
          border-radius: 100%;
          background-color: #000000;
          z-index: 10;
        } */
      }
    }
  }
`;

export const StyledUpgradeButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 10px 0px 0px 12px;
  height: 40px;
  width: 160px;
  > span {
    margin: 3px 0px 0px 5px;
  }
`;

export const StyledLeftMenuRoot = styled.div`
  text-align: center;
  padding: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 5px;
  /* padding-bottom: 40px; */
  background: ${({ theme }) => theme.colorBgBase};
  overflow: hidden auto;

  display: flex;
  flex-flow: column;
  justify-content: space-between;
`;

export const StyledLayout = styled(Layout)`
  .project-wrapper {
    display: flex;
    /* flex-wrap: wrap; */
    /* justify-content: center; */
    align-items: center;
  }
`;

export const StyledLeftMenuItemRoot = styled(Row).withConfig({
  shouldForwardProp: (props) => !["isSelected"].includes(props),
})<{ isSelected: Boolean }>`
  /* border-left: 4px solid ${({ isSelected }) =>
    isSelected ? "#00CCE1" : "rgba(0, 0, 0, 0)"}; */
  color: ${({ isSelected }) => (isSelected ? "#008CF2" : "inherit")};
  background: ${({ isSelected }) => (isSelected ? "#F1F1F1" : "inherit")};
  height: 44px;
  padding: 10px;
  width: 100%;

  cursor: pointer;

  &:hover {
    color: #008cf2;

    .menuCol svg {
      stroke: #008cf2;
    }
  }

  .menuCol {
    display: flex;
    font-size: 14px;
    font-family: ${poppins.string};

    &:hover {
      svg {
        stroke: #008cf2;
      }
    }
  }

  .menuSpace {
    padding-left: 8px;
    svg {
      stroke: ${({ isSelected }) => (isSelected ? "#008CF2" : "#272727")};
    }
  }

  .ant-space-item {
    display: flex;
    align-items: center;
  }
`;

export const StyledStudiosV2Item = styled(Row)`
  height: 36.5px;
  margin: 0 18px;
  border-radius: 7px;
  background: #e5eeff;
  cursor: pointer;

  span {
    font-size: 12px;
    font-weight: 500;
  }
`;

export const StyledStudiosV2ItemCol = styled.div<{
  $justifyContent?: string;
  $paddingLeft?: number;
}>`
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: ${(props) =>
    props.$justifyContent ? props.$justifyContent : "center"};
  padding-left: ${(props) => (props.$paddingLeft ? props.$paddingLeft : "")};

  .link-btn {
    color: inherit;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }

  .link-btn-text {
    &:hover {
      color: #008cf2;
    }

    text-decoration: underline;
  }
`;

export const StyledWorkspaceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledWorkspaceName = styled.div`
  width: 130px;
  font-family: ${Inter.string};
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProfileInfoWrapper = styled.div`
  /* width: calc(100% - 65px); */
  width: 110px;
  justify-content: center;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 5px;

  > span {
    font-family: ${Inter.string};
    font-size: 14px;
    line-height: 17px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 110px;
    /* width: calc(100% - 1px); */
  }
`;

export const ProfileInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  span {
    color: #a0a0a0;
    font-family: ${Inter.string};
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: left;
  }
`;

export const StyledWorkspaceInfo = styled.div`
  width: calc(100% - 35px);
  display: flex;
  /* gap: 10px; */
  align-items: center;
  justify-content: flex-start;
  margin-left: 35px;

  span {
    color: #a0a0a0;
    font-family: ${Inter.string};
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const StyledWorkspaceMember = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  span {
    color: #a0a0a0;
    font-family: ${poppins.string};
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 15px; /* 150% */
  }
`;

export const WorkspaceMemberInfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PlanUpgradeWrapper = styled.div`
  width: 100%;

  font-family: ${poppins.string};
  text-align: left;
  padding: 15px 10px 0px 10px;

  .content {
    border-radius: 7px;
    width: 100%;
    border: 1px solid #00000026;
    background-color: #f1f2f44d;
    padding: 15px;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #444444;
      display: flex;
      gap: 4px;
    }

    .remaining {
      display: flex;
      flex-direction: column;
      margin-top: 12px;

      .video-left {
        display: flex;
        font-size: 14px;
        color: #00000099;
        gap: 4px;

        span {
          color: #000000cc;
        }

        .unlimited {
          color: #4276ee;
        }
      }

      .time-left {
        display: flex;
        gap: 2px;
        font-size: 12px;
        color: #00000099;
        span {
          color: #4276ee;
        }
      }
    }

    .upgrade-container {
      margin-top: 12px;
      .message {
        font-size: 12px;
        color: #696969;
      }

      .upgrade-btn {
        cursor: pointer;
        color: #4276ee;
        font-weight: 600;
        font-size: 14px;
        svg {
          stroke: currentColor;
        }
      }
    }
  }
`;

export const TimeLeftInfoDiv = styled.div`
  display: flex;
  gap: 2px;
  font-size: 12px;
  color: #00000099;
  span {
    color: #4276ee;
  }
`;
